import React from 'react';
import OrderingControls from "./card/ordering-controls";
import ProductImage from "../common/product/product-image";
import { connect } from 'react-redux';
import QuantityControls from './card/quantity-controls';

import './new-feature.css';
import './card.css';

class NewFeaturedProductInner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labels: {},
      quantity_counter: 0
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.basket.line_items[this.props.product.id] !== prevProps.basket.line_items[this.props.product.id]) {
      this.setState({
        quantity_counter: this.props.basket.line_items[this.props.product.id] ? this.props.basket.line_items[this.props.product.id].product_qty : 0
      }, this.setProductStatus);
    }
  }

  componentDidMount = () => {
    const { product } = this.props;

    this.setState({
      labels: {
        reward: product.attributes['special-reward'],
        new: true,
        inBasket: this.props.basket[product.id] ? true : false,
      }
    }, this.setProductStatus);

    if (this.refs.featuredProductTitleRef) {
      this.refs.featuredProductTitleRef.style.setProperty('color', this.renderTextColor(product.attributes['marketing-text-color']));
    }

    if (this.refs.featuredProductTextRef) {
      this.refs.featuredProductTextRef.style.setProperty('color', this.renderTextColor(product.attributes['marketing-text-color']));
    }
  }

  setQuantityCounter = (max_amount) => {
    this.setState({
      quantity_counter: Number(max_amount)
    })
  }

  handleQuantityInput = (e) => {
    e.preventDefault();

    if (Number(e.target.value)) {
      this.setState({
        quantity_counter: Number(e.target.value)
      });
    }
  }

  handleQuantityCount = (dir) => {
    if (dir === 'pos' && !Number(this.state.quantity_counter)) {
      this.setState({
        quantity_counter: Number(1)
      });
    } else if (dir === 'pos') {
      if (!Number.isInteger(this.state.quantity_counter)) {
        this.setState({
          quantity_counter: Number(1)
        });
      } else {
        this.setState({
          quantity_counter: Number(this.state.quantity_counter) + Number(1)
        });
      }
    } else if (dir === 'neg') {
      if (this.state.quantity_counter > 0) {
        this.setState({
          quantity_counter: Number(this.state.quantity_counter) - Number(1)
        });
      }
    }
  }

  renderTextColor = (color) => {
    switch (color) {
      case 'Yellow':
        return '#fab200';
      case 'Red':
        return '#ab182e';
      case 'Grey':
        return '#575756';
      case 'White':
        return '#fff';
      default:
        return color;
    }
  }

  setProductStatus() {
    if (this.props.basket[this.props.product.id]) {
      this.setState({
        labels: {
          ...this.state.labels,
          inBasket: true
        },
        status: 'in-basket'
      });
    } else {
      this.setState({
        labels: {
          ...this.state.labels,
          inBasket: false
        },
        status: ''
      });
    }
  }

  render() {
    let { product } = this.props;

    return (
      <div className="feature-product-outer-container">
        <div className="featured-product-container">
          <div className="featured-text-container">
            <div ref="featuredProductTitleRef" className="featured-product-title">
              {product.attributes['marketing-title']}
            </div>
            <div ref="featuredProductTextRef" className="featured-product-message">
              {product.attributes['marketing-text']}
            </div>
          </div>
          <div className="featured-product-bottom-container">
            <QuantityControls 
              handleQuantityCount={this.handleQuantityCount} 
              handleQuantityInput={this.handleQuantityInput} 
              quantity_counter={this.state.quantity_counter} 
              color={this.renderTextColor(product.attributes['marketing-text-color'])} />
            <OrderingControls
              setQuantityCounter={this.setQuantityCounter}
              quantity={this.state.quantity_counter}
              product={product}
              handleConfirmation={this.props.handleConfirmation}
              upsellToggle={this.upsellToggle}
              new_order_page={this.props.new_order_page}
              status={this.state.status} />
          </div>
        </div>
        <div className="featured-product-image-container">
          <ProductImage
            labels={this.state.labels}
            image={product.attributes.links ? product.attributes.links.image : product.attributes.image}
            productState={this.state.status}
          />
          <div className='product-details-container'>
            <h4>
              {product.attributes.name}
            </h4>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  basket: state.orders.new.basket,
})

export default connect(mapStateToProps)(NewFeaturedProductInner);



// WEBPACK FOOTER //
// ./src/components/new-order/new-featured-product-inner.jsx